import Component from '../vendor/Component'

export default class ReadMore extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._trigger = this._elem.querySelector('[data-read-more-trigger]')
    this._content = this._elem.querySelector('[data-read-more-content]')
    this._open = false
  }

  async mount() {
    if (this._options.enableWhen && !matchMedia(`only screen and ${this._options.enableWhen}`).matches) {
      window.addEventListener('resize', e => {
        if (matchMedia(`only screen and ${this._options.enableWhen}`).matches && !this._isMounted) {
          this.mount()
        } else if (!matchMedia(`only screen and ${this._options.enableWhen}`).matches && this._isMounted) {
          this.unmount()
          this._isMounted = false
        }
      }, { passive: true })
      return false
    }

    let contentFullHeight = this._content.scrollHeight
    let height = parseFloat(this._options.height)

    if (contentFullHeight > height) {
      this._content.style.maxHeight = `${this._options.height}`
      this._trigger.textContent = this._options.read_more

      this._trigger.addEventListener('click', e => {
        e.preventDefault()
        if (this._open) {
          this._content.style.maxHeight = `${this._options.height}`
          this._trigger.textContent = this._options.read_more
        } else {
          this._content.style.maxHeight = `${contentFullHeight}px`
          this._trigger.textContent = this._options.read_less
        }
        this._open = !this._open
      })
    } else {
      this._trigger.parentNode.removeChild(this._trigger)
    }

    this._isMounted = true
  }

  unmount() {
    this._content.style.maxHeight = `none`
  }
}